import { PipeTransform } from '@angular/core';
var HTMLSanitizerPipe = /** @class */ (function () {
    function HTMLSanitizerPipe() {
    }
    HTMLSanitizerPipe.prototype.transform = function (text) {
        return text.replace(/[\u00A0-\u9999<>\&]/gim, function (char) {
            return '&#' + char.charCodeAt(0) + ';';
        });
    };
    return HTMLSanitizerPipe;
}());
export { HTMLSanitizerPipe };
